import { Box, BoxProps, LoadingWheel, Stack, Text } from "@vinomofo/components";

import { CouponSummaryLine } from "./CouponGCSummaryLine";
import { CurrencyLabel } from "../currency";
import { PROMOTIONS_BANNER_TYPES } from "../../utils/constants";
import { useCart } from "../../hooks/use-cart";

export const CartShipping = (props: BoxProps): JSX.Element => {
  const { cart, isLoading, removeCoupon } = useCart();
  const { isGiftCardOnly, promotions, coupons, isFreeShipping } = cart;
  const { banners: promotionsBanners } = promotions;

  return (
    <>
      {/* Estimated Shipping */}
      <Box
        display="flex"
        width="100%"
        justifyContent="space-between"
        alignItems="start"
        padding={3}
        borderTop="1px solid"
        borderTopColor="divider"
        borderBottom={coupons.length > 0 ? "1px solid" : "none"}
        borderBottomColor={coupons.length > 0 ? "divider" : ""}
        {...props}
      >
        <>
          <Box>
            <Stack space={0}>
              <Text fontSize={1} color="heading">
                Standard Shipping
              </Text>
              {promotionsBanners && promotionsBanners.length > 0 ? (
                isFreeShipping ? (
                  promotionsBanners
                    .filter((item) => {
                      const formatText = item?.text?.replace(
                        /(<([^>]+)>)/gi,
                        ""
                      );
                      const freeShipping =
                        formatText.includes("free-shipping") ||
                        formatText.includes("free shipping") ||
                        formatText.includes("Free Shipping") ||
                        formatText.includes("Free shipping");
                      return !freeShipping;
                    })
                    .map((banner, i) => {
                      const formatText = banner?.text?.replace(
                        /(<([^>]+)>)/gi,
                        ""
                      );
                      return banner.type === PROMOTIONS_BANNER_TYPES.UPSELL ? (
                        <Text
                          fontSize={0}
                          fontWeight={500}
                          color="deal"
                          key={i}
                        >
                          {formatText}
                        </Text>
                      ) : (
                        <Text fontSize={0} fontWeight={400} key={i}>
                          {formatText}
                        </Text>
                      );
                    })
                ) : (
                  promotionsBanners.map((banner, i) => {
                    const formatText = banner?.text?.replace(
                      /(<([^>]+)>)/gi,
                      ""
                    );
                    return banner.type === PROMOTIONS_BANNER_TYPES.UPSELL ? (
                      <Text fontSize={0} fontWeight={500} color="deal" key={i}>
                        {formatText}
                      </Text>
                    ) : (
                      <Text fontSize={0} fontWeight={400} key={i}>
                        {formatText}
                      </Text>
                    );
                  })
                )
              ) : (
                <></>
              )}
            </Stack>
          </Box>
          {isLoading ? (
            <LoadingWheel borderWidth="5px" size="2em" />
          ) : (
            <Text fontSize="14px" color="primary" fontWeight={500}>
              <CurrencyLabel
                amount={cart?.shippingTotal}
                showFree={isGiftCardOnly || cart?.shippingTotal === 0}
              />
            </Text>
          )}
        </>
      </Box>

      {/* Coupons */}
      {coupons.length > 0
        ? coupons.map((coupon, i) => {
            return (
              <CouponSummaryLine
                key={i}
                coupon={coupon}
                onRemove={removeCoupon}
                loading={isLoading}
                {...props}
              />
            );
          })
        : null}
    </>
  );
};
